<template>
  <focus-page v-if="credentialsLoaded" :title="$t('resetPassword.title')" :message="message">
    <form v-if="userCredentials">
      <input type="hidden" autocomplete="email username" name="email" :value="userCredentials.email" />
       <po-input-field name="password" label-key="form.password.label" placeholder-key="form.password.placeholder" message-key="form.password.message" type="password" autocomplete="current-password" v-model="password" v-focus="true" />
       <wo-grid mod-stacked>
        <wo-column width="6" />
        <wo-column width="6" v-wo-v-align:center v-wo-align:right>
          <po-promise-button :disabled="!valid" label-key="resetPassword.action.update" @click="reset" type="submit" />
        </wo-column>
      </wo-grid>
    </form>
    <account-focus-footer slot="footer" />
  </focus-page>
</template>

<script>

import { mapState } from 'vuex'

import FocusPage from '@/components/layout/FocusPage'
import AccountFocusFooter from '@/components/identity/AccountFocusFooter'

import { DASHBOARD } from '@/routes/general'

import { credentialsRepository, identify } from '@/repository/identity'
import { UserCredential } from '@/model/identity'

export default {
  components: { FocusPage, AccountFocusFooter },
  props: {
    correlationId: String
  },
  data () {
    return {
      credentialsLoaded: false,
      error: false,
      password: undefined
    }
  },
  computed: mapState({
    userCredentials: state => state.identity.userCredential,
    valid () {
      return this.password
    },
    message () {
      return this.userCredentials ? this.$t('resetPassword.update', this.userCredentials) : this.$t('resetPassword.error.expired')
    }
  }),
  watch: {
    correlationId () {
      this.loadCredentials()
    }
  },
  created () {
    this.loadCredentials()
  },
  methods: {
    loadCredentials () {
      this.credentialsLoaded = false
      this.$store.dispatch(credentialsRepository.find, { id: this.correlationId })
        .finally(() => { this.credentialsLoaded = true })
    },
    reset ({ detail }) {
      if (this.valid) {
        this.$store.dispatch(credentialsRepository.update, { entity: UserCredential.ofReset(this.correlationId, this.password) })
          .then(this.resetSuccess)
          .catch(this.resetFailure)
          .finally(detail.resolve)
      } else {
        detail.resolve()
      }
    },
    resetSuccess () {
      identify(this.$store, true).then(() => {
        this.$router.push({ name: DASHBOARD })
      })
    },
    resetFailure () {
      this.error = true
    }
  }
}
</script>
